export const calculateWeaponStats = (weapon, abilityScores, proficiencyBonus) => {
    const isFinesse = weapon.properties && weapon.properties.includes('Finesse');
    const isRanged = weapon.properties && weapon.properties.some(p => p.includes('Range'));

    // Calculate Modifiers
    const strMod = Math.floor((abilityScores.strength - 10) / 2);
    const dexMod = Math.floor((abilityScores.dexterity - 10) / 2);

    let mod = strMod;
    // Use Dex if Ranged OR (Finesse AND Dex > Str)
    if (isRanged || (isFinesse && dexMod > strMod)) {
        mod = dexMod;
    }

    // Implicit proficiency for simplified tracker
    const attackBonus = mod + proficiencyBonus;
    const damageMod = mod;

    return { attackBonus, damageMod };
};

export const getUnarmedStats = (character) => {
    const { level, class: charClass, abilityScores, proficiencyBonus } = character;
    const strMod = Math.floor((abilityScores.strength - 10) / 2);
    const dexMod = Math.floor((abilityScores.dexterity - 10) / 2);

    let damageDie = '1';
    let mod = strMod;
    let type = 'Bludgeoning';

    if (charClass === 'Monk') {
        // Martial Arts
        if (dexMod > strMod) mod = dexMod;

        if (level < 5) damageDie = '1d4';
        else if (level < 11) damageDie = '1d6';
        else if (level < 17) damageDie = '1d8';
        else damageDie = '1d10';
    }

    return {
        attackBonus: mod + proficiencyBonus,
        damage: damageDie,
        damageMod: mod,
        damageType: type
    };
};

export const CLASS_FEATURES = {
    'Monk': [
        { name: 'Flurry of Blows', type: 'Bonus Action', cost: '1 Ki', desc: 'Make two unarmed strikes as a bonus action.' },
        { name: 'Patient Defense', type: 'Bonus Action', cost: '1 Ki', desc: 'Dodge as a bonus action.' },
        { name: 'Step of the Wind', type: 'Bonus Action', cost: '1 Ki', desc: 'Disengage or Dash as a bonus action, and jump distance is doubled.' },
        { name: 'Stunning Strike', type: 'Free', cost: '1 Ki', desc: 'Interfere with ki flow. Con save or stunned.' }
    ],
    'Rogue': [
        { name: 'Cunning Action', type: 'Bonus Action', cost: '', desc: 'Dash, Disengage, or Hide.' }
    ],
    'Fighter': [
        { name: 'Second Wind', type: 'Bonus Action', cost: '1 Use', desc: 'Regain 1d10 + Level HP.' },
        { name: 'Action Surge', type: 'Free', cost: '1 Use', desc: 'Take one additional action.' }
    ],
    'Barbarian': [
        { name: 'Rage', type: 'Bonus Action', cost: '1 Rage', desc: 'Enter rage for advantage on Str checks, resistance to bludgeoning/piercing/slashing.' }
    ]
};
